import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import EmployeeDetail from "@/pages/EmployeeDetail";
import Recruitment from "@/pages/Recruitment";
import Onboarding from "@/pages/Onboarding";
import OnboardingWizard from "@/pages/OnboardingWizard";
import Attendance from "@/pages/Attendance";
import Leave from "@/pages/Leave";
import Payroll from "@/pages/Payroll";
import MyPayslips from "@/pages/MyPayslips";
import Performance from "@/pages/Performance";
import Production from "@/pages/Production";
import Training from "@/pages/Training";
import Learning from "@/pages/Learning";
import Assets from "@/pages/Assets";
import Exit from "@/pages/Exit";
import MyResignation from "@/pages/MyResignation";
import MyOnboarding from "@/pages/MyOnboarding";
import Pip from "@/pages/Pip";
import Overtime from "@/pages/Overtime";
import Holidays from "@/pages/Holidays";
import TeamMapping from "@/pages/TeamMapping";
import MyTeam from "@/pages/MyTeam";
import Reports from "@/pages/Reports";
import Documents from "@/pages/Documents";
import Notifications from "@/pages/Notifications";
import MyProfile from "@/pages/MyProfile";
import Admin from "@/pages/Admin";
import ChangePassword from "@/pages/ChangePassword";
import { CareersHome, CareersJob } from "@/pages/Careers";
import CareersStatus from "@/pages/CareersStatus";

const Protected = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/careers" replace />} />
            <Route path="/login" element={<Login />} />

            {/* Public careers portal */}
            <Route path="/careers" element={<CareersHome />} />
            <Route path="/careers/status" element={<CareersStatus />} />
            <Route path="/careers/:id" element={<CareersJob />} />

            {/* Authenticated workspace */}
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/employees" element={<Protected roles={["hr","manager","team_lead","recruiter"]}><Employees /></Protected>} />
            <Route path="/employees/:id" element={<Protected roles={["hr","manager","team_lead","recruiter"]}><EmployeeDetail /></Protected>} />
            <Route path="/recruitment" element={<Protected roles={["hr","recruiter","manager"]}><Recruitment /></Protected>} />
            <Route path="/onboarding" element={<Protected roles={["hr","manager"]}><Onboarding /></Protected>} />
            <Route path="/onboarding/wizard" element={<Protected roles={["hr","manager","employee"]}><OnboardingWizard /></Protected>} />
            <Route path="/attendance" element={<Protected><Attendance /></Protected>} />
            <Route path="/leave" element={<Protected><Leave /></Protected>} />
            <Route path="/payroll" element={<Protected roles={["hr","finance"]}><Payroll /></Protected>} />
            <Route path="/my/payslips" element={<Protected><MyPayslips /></Protected>} />
            <Route path="/performance" element={<Protected><Performance /></Protected>} />
            <Route path="/production" element={<Protected><Production /></Protected>} />
            <Route path="/training" element={<Protected><Training /></Protected>} />
            <Route path="/learning" element={<Protected><Learning /></Protected>} />
            <Route path="/assets" element={<Protected roles={["hr","it"]}><Assets /></Protected>} />
            <Route path="/exit" element={<Protected roles={["hr","manager"]}><Exit /></Protected>} />
            <Route path="/my/resign" element={<Protected><MyResignation /></Protected>} />
            <Route path="/my/onboarding" element={<Protected><MyOnboarding /></Protected>} />
            <Route path="/pip" element={<Protected roles={["hr","manager","team_lead"]}><Pip /></Protected>} />
            <Route path="/ot" element={<Protected><Overtime /></Protected>}/>
            <Route path="/holidays" element={<Protected><Holidays /></Protected>}/>
            <Route path="/team-mapping" element={<Protected roles={["hr","manager","team_lead","super_admin"]}><TeamMapping /></Protected>}/>
            <Route path="/my-team" element={<Protected roles={["manager","team_lead","hr","super_admin"]}><MyTeam /></Protected>}/>
            <Route path="/reports" element={<Protected roles={["hr","finance","manager"]}><Reports /></Protected>} />
            <Route path="/documents" element={<Protected roles={["hr","manager","finance","it","recruiter"]}><Documents /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/profile" element={<Protected><MyProfile /></Protected>} />
            <Route path="/admin" element={<Protected roles={["super_admin"]}><Admin /></Protected>} />
            <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/careers" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
